import { ajaxT } from 'util'

/**
 * 附近的小白车站点(大约1500米内)
 */

export function getNearStation(params) {
  return ajaxT.post('xbc/getNearXbcStation', params)
}

/**
 * 获取线路信息
 */
export function getXbcLine(params) {
  return ajaxT.post('xbc/getXbcLine', params).then(res => res.data)
}

/**
 * 获取小白车线路上的车辆定位
 */
export function getXbcVehicleByLine(params) {
  return ajaxT.post('xbc/getXbcVehicleByLine', params).then(res => res.data)
}
/**
 * 获取小白车到站信息
 */
export function getXbcVehicleRun(params) {
  return ajaxT.post('xbc/getXbcVehicleRun', params).then(res => res.data)
}
